import styles from "./index.module.css";
const PlayIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 19.0002C0 8.50683 8.50659 0.000244141 19 0.000244141C29.4934 0.000244141 38 8.50683 38 19.0002C38 29.4937 29.4934 38.0002 19 38.0002C8.50659 38.0002 0 29.4937 0 19.0002Z"
      fill="#FFD900"
    />
    <path
      d="M27.0205 18.452C27.025 18.7932 26.954 19.1311 26.8127 19.4416C26.6643 19.7702 26.4367 20.0552 26.1497 20.2729L16.6002 27.7046C16.264 27.961 15.8631 28.1186 15.4424 28.1599H15.2148C14.8708 28.16 14.5317 28.0786 14.2252 27.9224C13.8533 27.7398 13.5386 27.4587 13.3153 27.1098C13.092 26.7608 12.9686 26.3573 12.9585 25.9432V12.089C12.9565 11.6801 13.0696 11.2788 13.2851 10.9312C13.4936 10.5836 13.7922 10.2989 14.1494 10.1073C14.5065 9.91565 14.9088 9.82421 15.3137 9.84266C15.7214 9.86245 16.1173 9.98912 16.4616 10.2088L26.021 16.5817C26.312 16.7836 26.5554 17.0468 26.7335 17.3536C26.9215 17.6901 27.0205 18.0671 27.0205 18.452Z"
      fill="black"
    />
  </svg>
);
const MiniGameCard = ({ game, onClick }: { game: any, onClick: () => void }) => {
  return (
    <div
      className={`${styles.card}`}
      style={{ padding: "4px", borderRadius: "20px" }}
      onClick={onClick}
    >
      <div>
        <img className={styles.image} src={game.image} alt={game.name} width={722} height={240} loading="lazy" decoding="async" />
      </div>
      <div className={`flex-row ${styles.wrapper}`}>
        <div className={styles.info}>
          <div className={styles.name}>{game.name}</div>
          <div className={styles.description}>{game.description}</div>
        </div>
        <div className={`flex-right`}>
          <PlayIcon />
        </div>
      </div>
    </div>
  );
};
export default MiniGameCard;
